class Card {
  constructor(shape, number) {
    this.shape = shape;
    this.number = number;
  }
}

export default Card;
